/** Fase 8 — indicador "créditos de IA restantes" (cabeçalho do painel e da tela do assistente). */
import { useQuery } from "@tanstack/react-query";
import { Sparkles } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { aiQueries } from "@/lib/ai-api";
import { cn } from "@/lib/utils";

export function CreditsBadge({ workspaceId, className }: { workspaceId: string; className?: string }) {
  const status = useQuery(aiQueries.status(workspaceId));
  if (!status.data) return null;
  const q = status.data.quota;
  const low = q.remainingCredits <= Math.max(5, Math.ceil(q.monthlyCredits * 0.1));
  const empty = q.remainingCredits === 0;
  return (
    <Badge
      variant={empty ? "destructive" : low ? "warning" : "secondary"}
      className={cn("gap-1 font-normal", className)}
      title={`${q.usedCredits} de ${q.monthlyCredits} créditos usados em ${q.month}. 1 crédito = 1.000 tokens. A cota zera no início do próximo mês.${status.data.mode === "mock" ? " Modo simulado: respostas de exemplo, sem chave." : ""}`}
    >
      <Sparkles className="size-3" aria-hidden />
      {empty ? "Cota de IA esgotada" : `${q.remainingCredits} crédito${q.remainingCredits === 1 ? "" : "s"} de IA`}
      {status.data.mode === "mock" ? <span className="opacity-70">· simulado</span> : null}
    </Badge>
  );
}
